import React, { useRef, useState, useEffect } from "react";

const MultiSelect = (props) => {
  const contentRef = useRef(null);
  const [filter, setFilter] = useState("");
  const [optionsA, setOptionsA] = useState(props.options);
  const [isHovering, setIsHovering] = useState(props.isHovering);

  const handleMouseOver = (e) => {
    e.preventDefault();
    setIsHovering(true);
  };

  const handleMouseOut = (e) => {
    e.preventDefault();
    setIsHovering(false);
  };

  const handleOptionToggle = (option) => {
    const isSelected = props.selectedOptions.includes(option.value);
    let newSelectedOptions = [];

    if (isSelected) {
      if (option.value === "all") {
        newSelectedOptions = [];
      } else {
        newSelectedOptions = props.selectedOptions.filter(
          (selectedOption) => selectedOption !== option.value
        );
      }
    } else {
      if (option.value === "all") {
        optionsA.map((el) => {
          newSelectedOptions.push(el.value);
        });
      } else {
        newSelectedOptions = [...props.selectedOptions, option.value];
      }
    }

    props.setSelectedOptions(newSelectedOptions);
    props.onChange(newSelectedOptions);
  };

  const changeFilter = (e) => {
    e.preventDefault();
    setFilter(e.target.value);
    if (e.target.value.length === 0) {
      setOptionsA(props.options);
    } else {
      setOptionsA(
        props.options.filter((el) =>
          el.label
            .toString()
            .toLowerCase()
            .includes(e.target.value.toString().toLowerCase())
        )
      );
    }
  };

  const getSelected = () => {
    if (props.selectedOptions.length === 0) {
      return "Wybierz...";
    }
    if (props.selectedOptions.filter((e) => e === "all").length > 0) {
      return "Wszystkie opcje";
    }
    var retValue = "";
    props.selectedOptions.map((e) => {
      retValue = retValue + (e === "none" ? "Brak danych" : e) + ", ";
    });

    return retValue;
  };

  return (
    <div>
      {!props.isHovering ? (
        <>
          <div
            className="searchInput"
            id={props.id}
            style={{
              overflow: "scroll",
              overflowX: "hidden",
              height: "4vh",
              display: "flex",
              alignItems: "center",
              border: "1px solid black",
              fontSize: ".6vw",
              borderRadius: "5px",
              padding: "0px 10px",
            }}
            onClick={() => props.setIsHovering(!props.isHovering)}
          >
            <p id={props.id} style={{ margin: "0" }}>
              {getSelected()}
            </p>
          </div>
        </>
      ) : (
        ""
      )}
      {props.isHovering ? (
        <>
          <div
            className="searchInput"
            id={props.id}
            style={{
              backgroundColor: "#fff",
              border: "1px solid #000",
              borderRadius: "5px",
              boxShadow: "0 15px 24px -17px #42445a",
              boxSizing: "border-box",
              overflow: "scroll",
              height: "20vh",
              padding: "2px 5px 5px",
              position: "absolute",
              width: "23%",
              zIndex: "999",
            }}
          >
            <div id={props.id} style={{ display: "flex", gap: "10px" }}>
              <input
                id={props.id}
                style={{
                  marginBottom: "15px",
                  marginTop: "10px",
                  height: "3vh",
                  borderRadius: "5px",
                  width: "80%",
                }}
                type="text"
                value={filter}
                onChange={changeFilter}
              />
              <button
                id={props.id}
                style={{
                  height: "3.5vh",
                  marginTop: "10px",
                  cursor: "pointer",
                  fontSize: ".8vw",
                  fontWeight: "900",
                  borderRadius: "5px",
                  border: "1px solid blue",
                  backgroundColor: "blue",
                  color: "white",
                }}
                className="closeClientButton"
                onClick={() => props.setIsHovering(false)}
              >
                X
              </button>
            </div>

            {optionsA.map((option, index) => (
              <>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    borderBottom:
                      optionsA.length === index + 1 ? "none" : "1px solid gray",
                  }}
                >
                  <div style={{ width: "80%", fontSize: ".8vw" }}>
                    {option.label}
                  </div>
                  <div style={{ width: "20%", textAlign: "center" }}>
                    <input
                      style={{ width: "40%" }}
                      id={props.id}
                      className="checkInput"
                      type="checkbox"
                      checked={props.selectedOptions.includes(option.value)}
                      onChange={() => handleOptionToggle(option)}
                    />
                  </div>
                </div>
              </>
            ))}
          </div>
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default MultiSelect;
